// extracted by mini-css-extract-plugin
export default {"root":"fq-NDGys-3NRzWBWCJJt7","slideshow":"_2oVf-82Lem7KcHFYFwZeFT","singleImage":"grUQPi7zdah-sTCfx9He-"};